<template>
  <div>
    <div class="d-flex mt-2">
      <div
        style="position: relative"
        v-for="image in imagesList"
        :key="image.key"
        @mouseover="image.hover = true"
        @mouseleave="image.hover = false"
      >
        <img :src="image.src" alt="" class="history-image ma-1" />

        <div @click="open(image.key)">
          <div
            :style="image.hover ? 'opacity: 0.2;' : 'opacity: 0;'"
            class="expand-history-image ma-1"
          ></div>
          <v-icon
            :style="image.hover ? 'opacity: 1;' : 'opacity: 0;'"
            class="expand-icon"
            color="white "
          >
            mdi-arrow-expand
          </v-icon>
        </div>
      </div>
    </div>

    <v-dialog v-model="opened" max-width="850">
      <v-card>
        <v-card-text>
          <div class="pt-5">
            <v-carousel
              style="border-radius: 5px"
              width="500"
              height="800"
              hide-delimiters
              :value="firstImage"
            >
              <template v-slot:prev="{ on, attrs }">
                <v-btn
                  @click="prev()"
                  :disabled="firstImage === 0"
                  color="#466D9E"
                  fab
                  dark
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark> mdi-arrow-left </v-icon>
                </v-btn>
              </template>
              <template v-slot:next="{ on, attrs }">
                <v-btn
                  @click="next()"
                  :disabled="firstImage === lastImage"
                  color="#466D9E"
                  fab
                  dark
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark> mdi-arrow-right </v-icon>
                </v-btn>
              </template>

              <v-carousel-item
                style="border-radius: 20px; position: relative"
                v-for="image in imagesList"
                :key="image.key"
                :src="image.src"
              >
              </v-carousel-item>
            </v-carousel>
            <v-btn
              :loading="downloadLoading"
              @click="downloadImage(firstImage)"
              class="download-button"
              color="info"
              fab
              dark
              small
            >
              <v-icon dark> mdi-download </v-icon>
            </v-btn>
            <v-row class="d-flex pt-6 justify-center">
              <div class="" v-for="image in imagesList" :key="image.key">
                <img
                  @click="firstImage = image.key"
                  :style="
                    firstImage === image.key ? 'border: solid 4px #466D9E;' : ''
                  "
                  class="ma-1 carousel-bottom"
                  :src="image.src"
                  alt=""
                />
              </div>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <MessagesError
      :type="errorsType"
      :errors="errors"
      :error500="error500"
      @closeMessages="errors = []"
    />
  </div>
</template>

<script>
import download from "downloadjs";
import { mapActions } from "vuex";
import MessagesError from "../MessagesError.vue";
export default {
  name: "NfeHistoryImage",
  props: {
    images: {
      default: () => [],
      type: Array,
    },
  },
  components: {
    MessagesError,
  },
  data: () => ({
    opened: false,
    hover: false,
    firstImage: 0,
    lastImage: null,
    imagesList: [],
    downloadLoading: false,
    errors: [],
    errorsType: "error",
    error500: null,
  }),
  mounted() {
    this.imagesList = this.images.imagesList = this.images.map((image, key) => {
      return { id: image.id, src: image.src, hover: false, key: key };
    });
    this.lastImage = this.images.length - 1;
  },
  methods: {
    ...mapActions("NfeStore", [
      "fetchDownloadNfeJustificationsAttachmentsImage",
    ]),
    open(index) {
      this.opened = true;
      this.firstImage = index;
    },
    next() {
      this.firstImage++;
    },
    prev() {
      this.firstImage--;
    },
    async downloadImage(key) {
      this.downloadLoading = true;
      const image = this.imagesList.find((image) => image.key === key);
      try {
        const data = await this.fetchDownloadNfeJustificationsAttachmentsImage(
          image.id
        );

        if (data.Status === 500) {
          this.errors = ["Ops, algo deu errado!"];
          this.errorsType = "error";
          this.error500 = data;
        } else {
          download(data);
        }
      } catch (err) {
        // console.log(err);
        this.errorsType = "error";
        this.errors = ["Erro ao tentar baixar a imagem!"];
        this.error500 = err;
      } finally {
        this.downloadLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.history-image {
  width: 100px;
  border-radius: 5px;
  cursor: pointer;
}
.expand-icon {
  position: absolute;
  top: 6px;
  right: 6px;
  cursor: pointer;
  transition: 0.3s;
}
.expand-history-image {
  position: absolute;
  width: 100px;
  height: 100px;
  background: black;
  top: 0;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
}
.download-button {
  position: absolute;
  top: 30px;
  right: 35px;
}
.carousel-bottom {
  height: 100px;
  border-radius: 5px;
  cursor: pointer;
}
</style>
